import * as api from './api'

export { api }

export default api
